import translate from "@insite/client-framework/Translate";

export const translatedStatus = (status: string) => {
    switch(status) {
        case "QuoteRequested":
            return translate("Quote Requested");              
        case "QuoteRejected":
            return translate("Quote Rejected");   
        case "QuoteCreated":
            return translate("Quote Created");   
        default:
          return ""
      }
}